import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { UserResolver } from "@data/resolvers/user/user.resolver";
import { OtpComponent } from "@modules/payment-method/modules/otp/otp.component";

const routes: Routes = [
  {
    path: "renovacao/:id",
    children: [
      {
        path: "",
        component: OtpComponent,
      },
      {
        path: "metodo-de-pagamento",
        resolve: {
          user: UserResolver,
        },
        loadChildren: () =>
          import("./modules/payment-method/payment-method.module").then(
            (m) => m.PaymentMethodModule,
          ),
      },
    ],
  },
  {
    path: "pagina-nao-encontrada",
    loadChildren: () =>
      import("./modules/page-not-found/page-not-found.module").then((m) => m.PageNotFoundModule),
  },

  //Non handled routes
  {
    path: "**",
    redirectTo: "/pagina-nao-encontrada",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: "emptyOnly" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
